import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
import { ADMIN_SESSION_EVENT, getSelectedAdminSession, sessionParam } from "../utils/adminSession";

const API = "/backend/public/api";
const uploadsBase = "/uploads";

function ViewStudents() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRows = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/student-applications/approved`, {
        params: { workflow_stage: "registered", session_year: sessionParam(), _ts: Date.now() },
      });
      setRows(res.data || []);
    } catch (error) {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRows();
    const reload = () => loadRows();
    window.addEventListener(ADMIN_SESSION_EVENT, reload);
    return () => window.removeEventListener(ADMIN_SESSION_EVENT, reload);
  }, []);

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
          <div>
            <h3 className="mb-1">View Registered Student</h3>
            <p className="text-muted mb-0">Session: {getSelectedAdminSession()} | Students accepted by master admin move here with registration number and image preview.</p>
          </div>
          <button className="btn btn-dark" onClick={loadRows} disabled={loading}>
            {loading ? "Loading..." : "Refresh"}
          </button>
        </div>

        <div className="table-responsive bg-white shadow-sm rounded-4 p-2">
          <table className="table align-middle mb-0">
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Registration No</th>
                <th>Student</th>
                <th>Course</th>
                <th>Session</th>
                <th>Study Centre Name</th>
                <th>State</th>
                <th>District</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                rows.map((row, index) => (
                  <tr key={row.id}>
                    <td>{index + 1}</td>
                    <td>{row.registration_no || "-"}</td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={row.photo ? `${uploadsBase}/${row.photo}` : "https://placehold.co/52x52/e2e8f0/475569?text=ST"}
                          alt={row.student_name}
                          style={{ width: "52px", height: "52px", borderRadius: "14px", objectFit: "cover", border: "1px solid #e2e8f0" }}
                        />
                        <div>
                          <div className="fw-semibold">{row.student_name}</div>
                          <div className="text-muted small">{row.application_no || "-"}</div>
                        </div>
                      </div>
                    </td>
                    <td>{row.course_name || "-"}</td>
                    <td>{row.session_year || "-"}</td>
                    <td>{row.study_centre_name || "-"}</td>
                    <td>{row.state_name || "-"}</td>
                    <td>{row.district_name || "-"}</td>
                    <td className="text-capitalize">{row.status || "-"}</td>
                  </tr>
                ))}
              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center py-4 text-muted">
                    No approved students found.
                  </td>
                </tr>
              )}
              {loading && (
                <tr>
                  <td colSpan="9" className="text-center py-4 text-muted">
                    Loading approved students...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ViewStudents;



